export default "__VITE_PUBLIC_ASSET__0dcd13ce__"